import React from 'react';
import { UncontrolledCarousel } from 'reactstrap';
import Gambar1 from "./Image/gambar1.jpg"
import Gambar2 from "./Image/gambar2.jpg"
import Gambar3 from "./Image/gambar3.jpg"

const items = [
  {
    src: Gambar1,
    // altText: 'Slide 1',
     caption: 'Upcoming Movie in March',
    header: 'Watch Now',
    key: '1'
  },
  {
    src: Gambar2,
    // altText: 'Slide 2',
    caption: 'Upcoming Movie in March',
    header: 'Watch Now',
    key: '2'
  },
  {
    src: Gambar3,
    // altText: 'Slide 3',
    caption: 'Upcoming Movie in March',
    header: 'Watch Now',
    key: '3'
  }
];

const Example = () =><div style={{width:"90%", margin:"auto", paddingTop:"10px", height:"60%"}}><UncontrolledCarousel items={items} /></div>;

export default Example;